// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__Tdbea","content":"NotFound_content__OR3QY"};